/**
 * Myanmar kyat.
 */
export var MMK = {
  code: 'MMK',
  base: 10,
  exponent: 2
};